// export const API_BASE_URL = `https://api.thecaloriefinder.com`
// export const API_BASE_URL = "http://192.168.1.149:3001"
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
export const BUCKET_URL = process.env.REACT_APP_BUCKET_URL
export const SITE_URL = process.env.REACT_APP_SITE_URL

